<template>
    <a-layout>
        <Header>
            <template slot="head">
                <a-button v-if="mobile" class="drawer-handler"
                    icon="unordered-list" @click="showDrawer" 
                ></a-button>
                <a-drawer v-if="mobile"
                    placement="left"
                    :closable="false" :visible="visible"
                    @close="onClose"
                >
                    <Menu></Menu>
                </a-drawer>
            </template>
        </Header>
        <a-layout>
            <a-layout-sider v-if="!mobile" width="180" class="left-menu" style="background: #fff">
                <Menu></Menu>
            </a-layout-sider>
            <a-layout class="main-brench">
                <div class="main-header">
                    <h2>{{ $route.meta.title }}</h2>
                </div>
                <div class="main-content">
                    <keep-alive>
                        <router-view/>
                    </keep-alive>
                </div>
            </a-layout>
        </a-layout>
    </a-layout>
</template>

<script>
import Header from '@/components/Header'
import Menu from './Menu.vue'

const handle = window.matchMedia('(max-width: 600px)');

export default {
    name: 'App',
    data: () => ({
        visible: false,
        mobile: handle.matches,
    }),
    created() {
        handle.onchange = (e) => this.mobile = e.matches;
    },
    methods: {
        showDrawer() {
            this.visible = true;
        },
        onClose() {
            this.visible = false;
        },
    },
    components: {
        Header, Menu
    },
};
</script>

<style lang="less" scoped>
.drawer-handler {
    margin: 15px;
    margin-left: 0px;
}
.main-header {
    background: #fff;
    text-align: left;
    h2 {
        padding: 0 10px;
        margin: 6px 12px;
        border-bottom: solid 1px rgba(0, 0, 0, 0.25);
    }
}
.main-content {
    background: #fff;
    margin: 0;
    min-height: 280px;
    height:calc(100% - 30px);
}
@media screen and (min-width: 600px) {
    .main-brench {
        padding: 24px
    }
    .main-content {
        padding: 16px
    }
}
@media screen and (max-width: 600px) {
    .main-brench {
        padding: 0
    }
    .main-content {
        padding: 12px
    }
}
</style>